import React from 'react';
import s from './NoContent.module.less';
import { LoadingOutlined } from '@ant-design/icons';
import { Empty } from 'antd';

interface Props {
  gridHeight: number;
  totalColumnsWidth: number;
  mode: 'loading' | 'empty-no-filters' | 'empty-with-filters';
}

export const NoContent = ({ mode, totalColumnsWidth, gridHeight }: Props) => (
  <div style={{ height: gridHeight }}>
    <div className={s.NoContent} style={{ width: totalColumnsWidth }}>
      {mode === 'loading' && <LoadingOutlined />}
      {mode === 'empty-no-filters' && (
        <div>
          <Empty description={'Нет данных'} />
        </div>
      )}
      {mode === 'empty-with-filters' && (
        <div>
          <Empty description={'Нет данных по заданному фильтру'} />
        </div>
      )}
    </div>
  </div>
);
